/* eslint-disable react-hooks/exhaustive-deps */
import {
  Alert,
  Box,
  Checkbox,
  Snackbar,
  SnackbarCloseReason,
  Tab,
  Tabs,
} from "@mui/material"
import ExcelJS from "exceljs"
import { useEffect, useState } from "react"
import {
  Button,
  Col,
  Container,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap"
import { Link, useParams } from "react-router-dom"
import { API_ENDPOINTS } from "../../api/endpoints"
import { useSpinner } from "../../contexts/SpinnerProvider"
import { useApi } from "../../hooks/useApi"
import { Action, Column } from "../../interfaces/CamposTablaGenerica"
import { IEgresados } from "../../interfaces/IEgresados"
import { IEventos } from "../../interfaces/IEventos"
import { ILinkPublicoResponse } from "../../interfaces/ILinkPublico"
import {
  IRecibo,
  IReciboEventoRequest,
  IReciboRequest,
} from "../../interfaces/IRecibo"
import { CategoriaInvitado, TipoEvento } from "../../interfaces/TipoEvento"
import { copyDataEgresado } from "../../utils/claveAndEncryptUtils"
import { formatDateGuiones } from "../../utils/dateUtils"
import {
  buildQrPublicLinkMessage,
  buildWhatsappUrl,
  formatPublicLinkExpiration,
  hasQrTickets,
} from "../../utils/publicLinkUtils"
import { capitalizeNombresPropios } from "../../utils/StringUtils"
import { getFieldConfig, labelInvitado } from "../../utils/tipoEventoTheme"
import GenericTable from "../GenericTable/GenericTable"
import SkeletonGrid from "../Skeleton/SkeletonGrid"
import AddEgresadoModal from "./AddEgresadoModal"
import ModalGeneradorQR from "./BusquedaEgresados/ModalGeneradorQR"
import EditEgresadoModal from "./EditEgresadoModal/EditEgresadoModal"
import ImportExcelModal from "./ImportExcelModal"
import RecibosEventoModal from "./Recibos/RecibosEventoModal/RecibosEventoModal"
import RecibosModal from "./Recibos/RecibosModal/RecibosModal"
import TelefonoWhatsappModal from "../TelefonoWhatsappModal/TelefonoWhatsappModal"
import QrNoTicketsModal from "../QrNoTicketsModal/QrNoTicketsModal"
import "./Egresados.css"

const Egresados = () => {
  const [egresados, setEgresados] = useState<IEgresados[]>([])
  const [editModalShow, setEditModalShow] = useState(false)
  const [recibosModalShow, setRecibosModalShow] = useState(false)
  const [addModalShow, setAddModalShow] = useState(false)
  const [importExcelShow, setImportExcelShow] = useState(false)
  const API_URL = API_ENDPOINTS.EGRESADOS
  const API_URL_RECIBOS = API_ENDPOINTS.RECIBOS
  const API_URL_EVENTOS = API_ENDPOINTS.EVENTOS
  const [deleteConfirmation, setDeleteConfirmation] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState<IEgresados | null>(
    null,
  )
  const [showDeleteAllConfirmation, setShowDeleteAllConfirmation] =
    useState(false)
  const [selectedEditUsuario, setSelectedEditUsuario] =
    useState<IEgresados | null>(null)
  const [, setSelectedRecibos] = useState<IRecibo | null>(null)
  const api = useApi()
  const { addLoading, removeLoading } = useSpinner()
  const [skeletonLoading, setSkeletonLoading] = useState(false)
  const { id } = useParams()
  const idEvento = id || ""
  const tieneEvento = idEvento !== ""
  const [tituloEvento, setTituloEvento] = useState("")
  const [telefonoEvento, setTelefonoEvento] = useState("")
  const [nombreClienteEvento, setNombreClienteEvento] = useState("")
  const [totalMesaDulce, setTotalMesaDulce] = useState(0)
  const [totalPosCena, setTotalPosCena] = useState(0)
  const [totalBarra, setTotalBarra] = useState(0)
  const [tipoEvento, setTipoEvento] = useState<TipoEvento | undefined>(
    undefined,
  )
  const [showSecondDeleteConfirmation, setShowSecondDeleteConfirmation] =
    useState(false)
  const [copyMessage, setCopyMessage] = useState<string>("")
  const [qrNoTicketsOpen, setQrNoTicketsOpen] = useState(false)
  const [qrNoTicketsMessage, setQrNoTicketsMessage] = useState("")
  const [snackbarOpenError, setSnackbarOpenError] = useState(false)
  const [snackbarMessageError, setSnackbarMessageError] = useState<string>("")
  const [idEgresado, setIdEgresado] = useState("")
  const [showGenerarReciboConfirm, setShowGenerarReciboConfirm] =
    useState(false)
  const [egresadoParaRecibo, setEgresadoParaRecibo] =
    useState<IEgresados | null>(null)
  const [recibosEventoModalShow, setRecibosEventoModalShow] = useState(false)
  const [dniQR, setDniQR] = useState(0)
  const [claveQR, setClaveQR] = useState("")
  const [idQR, setIdQR] = useState(0)
  const [tipoEventoQR, setTipoEventoQR] = useState<string | undefined>(
    undefined,
  )
  const [categoriaQR, setCategoriaQR] = useState<string | undefined>(undefined)
  const [openQRModal, setOpenQRModal] = useState(false)
  const [egresadoWhatsappPendiente, setEgresadoWhatsappPendiente] =
    useState<IEgresados | null>(null)
  const [telefonoWhatsapp, setTelefonoWhatsapp] = useState("")
  const [guardandoTelefonoWhatsapp, setGuardandoTelefonoWhatsapp] =
    useState(false)
  const [tabCategoria, setTabCategoria] = useState<CategoriaInvitado>(() => {
    const stored = localStorage.getItem(`tabsCenaBaile_${idEvento}`)
    return stored === CategoriaInvitado.BAILE
      ? CategoriaInvitado.BAILE
      : CategoriaInvitado.CENA
  })

  const callApiAndSetEgresados = async () => {
    setSkeletonLoading(true)
    try {
      const responseData = await api.get<IEgresados[]>(
        `${API_URL}?eventoId=${idEvento}`,
        { errorMessage: "Error al cargar los egresados" },
      )
      const sortedData = [...responseData].sort((a, b) =>
        a.apellido.toLowerCase().localeCompare(b.apellido.toLowerCase()),
      )
      setEgresados(sortedData)
    } catch {
      // toast ya mostrado
    } finally {
      setSkeletonLoading(false)
    }
  }

  const callApiAndSetEvento = async () => {
    if (!idEvento) return
    addLoading()
    try {
      const responseData = await api.get<IEventos>(`${API_URL_EVENTOS}/${idEvento}`, {
        errorMessage: "Error al obtener el evento",
      })
      setTituloEvento(
        `${responseData.nombre} / ${formatDateGuiones(responseData.fecha)}`,
      )
      setTipoEvento(responseData.tipo)
      setTelefonoEvento(responseData.telefono || "")
      setTotalMesaDulce(responseData.totalMesaDulce || 0)
      setTotalPosCena(responseData.totalPosCena || 0)
      setTotalBarra(responseData.totalBarra || 0)
      setNombreClienteEvento(
        `${capitalizeNombresPropios(responseData.nombreCliente || "")} ${capitalizeNombresPropios(
          responseData.apellidoCliente || "",
        )}`.trim(),
      )
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  const handleCheckboxChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    item: IEgresados,
  ) => {
    if (!item.id) return
    const newCheckedValue = event.target.checked
    addLoading()
    try {
      await api.put(
        `${API_URL}/${item.id}/revisado?estaRevisado=${newCheckedValue}`,
        undefined,
        { errorMessage: "Error al actualizar el estado de revision" },
      )
      setEgresados(
        egresados.map((egresado) =>
          egresado.id === item.id
            ? { ...egresado, estaRevisado: newCheckedValue }
            : egresado,
        ),
      )
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  // ##################################################

  useEffect(() => {
    callApiAndSetEvento()
    callApiAndSetEgresados()
  }, [])

  const actions: Action = {
    create: true,
    update: true,
    delete: true,
    export: true,
    copy: true,
    viewQR: true,
    sendPublicQrWhatsapp: true,
    onRecibos: tipoEvento !== TipoEvento.CUMPLEANIOS_BODAS,
  }

  const cfgTabla = getFieldConfig(
    tipoEvento,
    tipoEvento === TipoEvento.EGRESADOS ||
      tipoEvento === TipoEvento.CUMPLEANIOS_BODAS
      ? tabCategoria
      : CategoriaInvitado.GENERAL,
  )

  const handleButtonVerQR = (egresado: IEgresados) => {
    setDniQR(egresado.dni ?? 0)
    setClaveQR(egresado.clave)
    setIdQR(egresado.id)
    setTipoEventoQR(egresado.evento?.tipo || tipoEvento || undefined)
    setCategoriaQR(egresado.categoria || undefined)
    setOpenQRModal(true)
  }

  const handleCloseQRModal = () => setOpenQRModal(false)

  const sendPublicQrWhatsapp = async (egresado: IEgresados) => {
    addLoading()
    try {
      const link = await api.post<ILinkPublicoResponse>(
        `${API_URL}/${egresado.id}/link-publico-qr`,
        undefined,
        { errorMessage: "Error al generar el link publico de QR" },
      )
      const whatsappUrl = buildWhatsappUrl(
        egresado.telefono,
        buildQrPublicLinkMessage(egresado, link.url, link.expiraEn),
      )
      if (!whatsappUrl) {
        setCopyMessage("No hay telefono valido para enviar por WhatsApp")
        setTimeout(() => setCopyMessage(""), 3000)
        return
      }
      window.open(whatsappUrl, "_blank", "noopener,noreferrer")
      setCopyMessage(
        `WhatsApp abierto, el link expira el ${formatPublicLinkExpiration(
          link.expiraEn,
        )}`,
      )
      setTimeout(() => setCopyMessage(""), 3000)
    } catch (error) {
      console.error("Error al enviar QR por WhatsApp:", error)
    } finally {
      removeLoading()
    }
  }

  const handleSendPublicQrWhatsapp = async (egresado: IEgresados) => {
    if (!hasQrTickets(egresado.tarjetasPagadas, egresado.tarjetasPagadasMenores)) {
      setQrNoTicketsMessage(
        "No se puede enviar el QR porque no tiene tarjetas asignadas.",
      )
      setQrNoTicketsOpen(true)
      return
    }
    if (!egresado.telefono?.trim()) {
      setEgresadoWhatsappPendiente(egresado)
      setTelefonoWhatsapp("")
      return
    }
    await sendPublicQrWhatsapp(egresado)
  }

  const handleGuardarTelefonoYEnviarQr = async () => {
    if (!egresadoWhatsappPendiente || !telefonoWhatsapp.trim()) return
    setGuardandoTelefonoWhatsapp(true)
    addLoading()
    try {
      const actualizado = await api.put<IEgresados>(
        `${API_URL}/${egresadoWhatsappPendiente.id}`,
        { ...egresadoWhatsappPendiente, telefono: telefonoWhatsapp.trim() },
        { errorMessage: "Error al guardar el telefono" },
      )
      const egresadoActualizado = actualizado || {
        ...egresadoWhatsappPendiente,
        telefono: telefonoWhatsapp.trim(),
      }
      setEgresados((prev) =>
        prev.map((item) =>
          item.id === egresadoActualizado.id ? egresadoActualizado : item,
        ),
      )
      setEgresadoWhatsappPendiente(null)
      setTelefonoWhatsapp("")
      await sendPublicQrWhatsapp(egresadoActualizado)
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
      setGuardandoTelefonoWhatsapp(false)
    }
  }

  const columns: Column<IEgresados>[] = [
    {
      title: "Apellido",
      field: "apellido",
      render: (rowData) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              marginTop: "-8px",
            }}
          >
            <Checkbox
              checked={rowData.estaRevisado || false}
              onChange={(e) => handleCheckboxChange(e, rowData)}
              color="primary"
              style={{ marginRight: 8 }}
            />
            <span style={{ flexGrow: 1, textAlign: "center" }}>
              {capitalizeNombresPropios(rowData.apellido)}
            </span>
          </div>
        )
      },
    },
    {
      title: "Nombre",
      field: "nombre",
      render: (rowData) => (
        <span style={{ textAlign: "center", display: "block" }}>
          {capitalizeNombresPropios(rowData.nombre)}
        </span>
      ),
    },
    ...(tipoEvento !== TipoEvento.CUMPLEANIOS_BODAS
      ? [{ title: "DNI", field: "dni" } as Column<IEgresados>]
      : []),
    { title: "Contraseña", field: "clave" },
    ...(cfgTabla.telefonoMostrar
      ? [{ title: "Teléfono", field: "telefono" } as Column<IEgresados>]
      : []),
    ...(tipoEvento !== TipoEvento.FIESTAS &&
    tabCategoria !== CategoriaInvitado.BAILE
      ? [
          {
            title: "Observación/Mesa",
            field: "observaciones",
            render: (rowData: IEgresados) => {
              const maxLength = 4
              const obs = rowData.observaciones ?? ""
              const displayText =
                obs.length > maxLength
                  ? obs.substring(0, maxLength) + "..."
                  : obs
              const tooltip = (
                <Tooltip id={`tooltip-${rowData.id}`} placement="top">
                  {rowData.observaciones}{" "}
                </Tooltip>
              )
              return (
                <OverlayTrigger placement="top" overlay={tooltip}>
                  <span
                    style={{
                      width: "10%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      cursor: "pointer",
                    }}
                  >
                    {displayText}
                  </span>
                </OverlayTrigger>
              )
            },
          } as Column<IEgresados>,
        ]
      : []),
    { title: "Tarjetas Pagadas", field: "tarjetasPagadas" },
    ...(tabCategoria !== CategoriaInvitado.BAILE
      ? [
          {
            title: "Tarjetas Pagadas Menores",
            field: "tarjetasPagadasMenores",
          } as Column<IEgresados>,
        ]
      : []),
    ...(tipoEvento !== TipoEvento.CUMPLEANIOS_BODAS
      ? [
          {
            title: "Seña",
            field: "totalSeniaPagada" as keyof IEgresados,
            sortable: true,
            render: (rowData: IEgresados) => {
              // Prioridad: tarjetas > seña > nada
              if (
                rowData.tarjetasPagadas > 0 ||
                rowData.tarjetasPagadasMenores > 0
              ) {
                return (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-tarjetas-${rowData.id}`}>
                        Se pagaron tarjetas
                      </Tooltip>
                    }
                  >
                    <i className="bi bi-credit-card-fill text-primary fs-5"></i>
                  </OverlayTrigger>
                )
              } else if (
                rowData.totalSeniaPagada &&
                rowData.totalSeniaPagada > 0
              ) {
                return (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-senia-${rowData.id}`}>
                        Seña: $
                        {rowData.totalSeniaPagada.toLocaleString("de-DE", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Tooltip>
                    }
                  >
                    <i className="bi bi-check-circle-fill text-success fs-5"></i>
                  </OverlayTrigger>
                )
              }
              return null
            },
            customSort: (a: IEgresados, b: IEgresados) => {
              const getEstado = (row: IEgresados) => {
                if (row.tarjetasPagadas > 0 || row.tarjetasPagadasMenores > 0)
                  return 2
                if (row.totalSeniaPagada && row.totalSeniaPagada > 0) return 1
                return 0
              }
              return getEstado(a) - getEstado(b)
            },
          },
        ]
      : []),
  ]

  const customSearch = (searchText: string): Promise<IEgresados[]> => {
    return new Promise((resolve) => {
      const normalizedSearchText = normalizeString(searchText)
      const source = mostrarTabs
        ? egresados.filter((e) => e.categoria === tabCategoria)
        : egresados
      if (!normalizedSearchText) {
        resolve(source)
        return
      }
      const filteredData = source.filter((egresado) =>
        [egresado.nombre, egresado.apellido, egresado.dni, egresado.telefono]
          .filter((f) => f != null && f !== "")
          .some((field) =>
            normalizeString(field!.toString()).includes(normalizedSearchText),
          ),
      )
      resolve(filteredData)
    })
  }

  const normalizeString = (str: string): string => {
    return str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
  }

  const handleEgresadoAdd = async (egresado: IEgresados) => {
    addLoading()
    try {
      const newEgresado = await api.post<IEgresados>(API_URL, egresado, {
        errorMessage: "Error al agregar el egresado",
      })
      if (newEgresado) {
        setEgresados([...egresados, newEgresado])
        callApiAndSetEvento()
        callApiAndSetEgresados()
        setEgresadoParaRecibo(newEgresado)
        setShowGenerarReciboConfirm(true)
      }
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  const handleImportExcel = async (listaEgresados: IEgresados[]) => {
    addLoading()
    try {
      const newEgresado = await api.post<IEgresados | null>(
        `${API_URL}/saveAll`,
        listaEgresados,
        { errorMessage: "Error al importar egresados" },
      )
      if (newEgresado) {
        setEgresados([...egresados, newEgresado])
        callApiAndSetEgresados()
        callApiAndSetEvento()
      }
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  const handleEgresadoEdit = async (egresado: IEgresados) => {
    addLoading()
    try {
      const updatedEgresado = await api.put<IEgresados>(
        `${API_URL}/${egresado.id}`,
        egresado,
        { errorMessage: "Error al editar el egresado" },
      )
      if (updatedEgresado) {
        setEgresados(
          egresados.map((item) =>
            item.id === egresado.id ? updatedEgresado : item,
          ),
        )
        callApiAndSetEvento()
        callApiAndSetEgresados()
        setEgresadoParaRecibo(updatedEgresado)
        setShowGenerarReciboConfirm(true)
      }
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  const handleReciboAdd = async (recibo: IReciboRequest): Promise<void> => {
    addLoading()
    try {
      await api.post(API_URL_RECIBOS, recibo, {
        errorMessage: "Error al guardar el recibo",
      })
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  const handleReciboEventoAdd = async (
    recibo: IReciboEventoRequest,
  ): Promise<void> => {
    addLoading()
    try {
      await api.post(`${API_URL_RECIBOS}/evento`, recibo, {
        errorMessage: "Error al guardar el recibo del evento",
      })
      await callApiAndSetEvento()
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  const showDeleteConfirmation = (item: IEgresados) => {
    setSelectedToDelete(item)
    setDeleteConfirmation(true)
  }

  const handleDeleteConfirmation = async (confirmed: boolean) => {
    if (confirmed && selectedToDelete) {
      const egresadoId: number = selectedToDelete.id
      addLoading()
      try {
        await api.del(`${API_URL}/${egresadoId}`, {
          errorMessage: "Error al eliminar el egresado",
        })
        setEgresados(egresados.filter((item) => item.id !== egresadoId))
        callApiAndSetEvento()
      } catch {
        // toast ya mostrado
      } finally {
        removeLoading()
      }
    }
    setSelectedToDelete(null)
    setDeleteConfirmation(false)
  }

  const handleFinalDeleteAllEgresados = async () => {
    setShowSecondDeleteConfirmation(false)
    addLoading()
    try {
      const url = mostrarTabs
        ? `${API_URL}/deleteAll/${idEvento}?categoria=${tabCategoria}`
        : `${API_URL}/deleteAll/${idEvento}`
      await api.del(url, {
        errorMessage: "Error al eliminar los egresados",
      })
      if (mostrarTabs) {
        setEgresados((prev) => prev.filter((e) => e.categoria !== tabCategoria))
      } else {
        setEgresados([])
      }
    } catch {
      // toast ya mostrado
    } finally {
      removeLoading()
    }
  }

  const callApiAndSetEgresadoPorId = async (egresadoId: number) => {
    addLoading()
    try {
      const responseData = await api.get<IEgresados>(
        `${API_URL}/${egresadoId}`,
        { showErrorToast: false },
      )
      setSnackbarOpenError(false)
      setSelectedEditUsuario(responseData)
      setEditModalShow(true)
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Error desconocido"
      setSnackbarMessageError(
        `Error al buscar egresado para editar: ${message}`,
      )
      setSnackbarOpenError(true)
    } finally {
      removeLoading()
    }
  }

  const handleAddModalOpen = () => setAddModalShow(true)
  const handleAddModalClose = () => setAddModalShow(false)

  const handleImportExcelOpen = () => setImportExcelShow(true)
  const handleImportExcelClose = () => setImportExcelShow(false)

  const handleEditModalOpen = async (item: IEgresados) => {
    await callApiAndSetEgresadoPorId(item.id)
  }

  const handleEditModalClose = () => {
    setEditModalShow(false)
    setSelectedEditUsuario(null)
  }

  const handleShowDeleteAllConfirmation = () => {
    setShowDeleteAllConfirmation(true)
  }

  const handleCloseDeleteAllConfirmation = () => {
    setShowDeleteAllConfirmation(false)
  }

  const handleDeleteAllConfirmation = (confirmed: boolean) => {
    if (confirmed) {
      setShowDeleteAllConfirmation(false) // Cierra la primera confirmación
      setShowSecondDeleteConfirmation(true) // Muestra la segunda confirmación
    } else {
      setShowDeleteAllConfirmation(false) // Cierra la primera confirmación
    }
  }

  const handleRecibosModalOpen = async (item: IEgresados) => {
    setIdEgresado(item.id.toString())
    setRecibosModalShow(true)
  }

  const handleRecibosModalClose = () => {
    setRecibosModalShow(false)
    setSelectedRecibos(null)
  }

  const handleGenerarReciboConfirm = () => {
    if (egresadoParaRecibo) {
      if (tipoEvento === TipoEvento.CUMPLEANIOS_BODAS) {
        setRecibosEventoModalShow(true)
      } else {
        setIdEgresado(egresadoParaRecibo.id.toString())
        setRecibosModalShow(true)
      }
    }
    setShowGenerarReciboConfirm(false)
    setEgresadoParaRecibo(null)
  }

  const handleGenerarReciboCancel = () => {
    setShowGenerarReciboConfirm(false)
    setEgresadoParaRecibo(null)
  }

  //exportar a excel
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook()
    const esEgresados = tipoEvento === TipoEvento.EGRESADOS
    const cfgExport = getFieldConfig(
      tipoEvento,
      categoriaDefault ?? CategoriaInvitado.GENERAL,
    )
    const esBaile = categoriaDefault === CategoriaInvitado.BAILE
    const labelNombre = esEgresados
      ? "NOMBRE_DEL_EGRESADO"
      : "NOMBRE_DEL_INVITADO"
    const sheetName = esEgresados ? "Egresados" : "Invitados"
    const worksheet = workbook.addWorksheet(sheetName)

    type ColDef = { header: string; key: string; width: number }
    const headers: ColDef[] = [
      { header: labelNombre, key: "nombre", width: 30 },
      ...(cfgExport.dniMostrar
        ? [{ header: "DNI", key: "dni", width: 15 }]
        : []),
      ...(cfgExport.tarjetasBaile
        ? [
            { header: "TARJETAS_BAILE", key: "tarjetasPagadas", width: 20 },
            {
              header: "TARJETAS_INGRESADAS",
              key: "tarjetasIngresadas",
              width: 25,
            },
            {
              header: "TARJETAS_POR_INGRESAR",
              key: "tarjetasPorIngresar",
              width: 25,
            },
          ]
        : []),
      ...(cfgExport.tarjetasMayores
        ? [
            { header: "TARJETAS_PAGADAS", key: "tarjetasPagadas", width: 20 },
            {
              header: "TARJETAS_INGRESADAS",
              key: "tarjetasIngresadas",
              width: 25,
            },
            {
              header: "TARJETAS_POR_INGRESAR",
              key: "tarjetasPorIngresar",
              width: 25,
            },
            {
              header: "TARJETAS_PAGADAS_MENORES",
              key: "tarjetasPagadasMenores",
              width: 30,
            },
            {
              header: "TARJETAS_INGRESADAS_MENORES",
              key: "tarjetasIngresadasMenores",
              width: 35,
            },
            {
              header: "TARJETAS_POR_INGRESAR_MENORES",
              key: "tarjetasPorIngresarMenores",
              width: 35,
            },
            { header: "TARJETAS_TOTALES", key: "tarjetasTotales", width: 18 },
          ]
        : []),
      { header: "CLAVE", key: "clave", width: 30 },
      ...(cfgExport.telefonoMostrar
        ? [{ header: "TELÉFONO", key: "telefono", width: 20 }]
        : []),
      ...(cfgExport.emailMostrar
        ? [{ header: "EMAIL", key: "email", width: 40 }]
        : []),
      ...(cfgExport.menuMesa
        ? [
            { header: "MENU_OPCIONAL", key: "menuOpcional", width: 40 },
            { header: "OBSERVACIONES", key: "observaciones", width: 40 },
          ]
        : []),
    ]

    worksheet.columns = headers
    worksheet.getRow(1).font = { bold: true }
    for (let i = 2; i <= headers.length; i++) {
      worksheet.getColumn(i).alignment = { horizontal: "center" }
    }

    const dataParaExportar = egresadosFiltrados.map((e) => ({
      nombre: `${e.apellido}, ${e.nombre}`,
      ...(cfgExport.dniMostrar ? { dni: e.dni } : {}),
      ...(cfgExport.tarjetasBaile || cfgExport.tarjetasMayores
        ? {
            tarjetasPagadas: e.tarjetasPagadas,
            tarjetasIngresadas: e.tarjetasIngresadas,
            tarjetasPorIngresar: e.tarjetasPorIngresar,
          }
        : {}),
      ...(cfgExport.tarjetasMayores
        ? {
            tarjetasPagadasMenores: e.tarjetasPagadasMenores,
            tarjetasIngresadasMenores: e.tarjetasIngresadasMenores,
            tarjetasPorIngresarMenores: e.tarjetasPorIngresarMenores,
            tarjetasTotales: e.tarjetasPagadas + e.tarjetasPagadasMenores,
          }
        : {}),
      clave: e.clave,
      ...(cfgExport.telefonoMostrar ? { telefono: e.telefono } : {}),
      ...(cfgExport.emailMostrar ? { email: e.email } : {}),
      ...(cfgExport.menuMesa
        ? { menuOpcional: e.menuOpcional, observaciones: e.observaciones }
        : {}),
    }))

    dataParaExportar.forEach((data) => worksheet.addRow(data))

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: "application/octet-stream" })
    const link = document.createElement("a")
    link.href = window.URL.createObjectURL(blob)
    const sufijo = mostrarTabs ? `_${esBaile ? "Baile" : "Cena"}` : ""
    link.download = `${tituloEvento}${sufijo}.xlsx`
    link.click()
  }

  const handleCopy = (egresado: IEgresados) => {
    copyDataEgresado(egresado, setCopyMessage).catch((error) => {
      console.error("Error al copiar:", error)
    })
  }

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === "clickaway") {
      return
    }
    setSnackbarOpenError(false)
  }

  const mostrarTabs =
    tipoEvento === TipoEvento.EGRESADOS ||
    tipoEvento === TipoEvento.CUMPLEANIOS_BODAS

  const deleteAllLabel = mostrarTabs
    ? `Borrar todos ${tabCategoria === CategoriaInvitado.BAILE ? "baile" : "cena"}`
    : `Borrar todos los ${labelInvitado(tipoEvento)}s`

  const egresadosFiltrados = mostrarTabs
    ? egresados.filter((e) => e.categoria === tabCategoria)
    : egresados

  const totalMayores = egresados
    .filter((e) => e.categoria !== CategoriaInvitado.BAILE)
    .reduce((sum, e) => sum + (e.tarjetasPagadas || 0), 0)
  const totalMenores = egresados
    .filter((e) => e.categoria !== CategoriaInvitado.BAILE)
    .reduce((sum, e) => sum + (e.tarjetasPagadasMenores || 0), 0)
  const totalBaile = egresados
    .filter((e) => e.categoria === CategoriaInvitado.BAILE)
    .reduce((sum, e) => sum + (e.tarjetasPagadas || 0), 0)
  const totalCena = totalMayores + totalMenores
  const totalGeneral = totalCena + totalBaile

  const categoriaDefault: CategoriaInvitado | undefined = !mostrarTabs
    ? CategoriaInvitado.GENERAL
    : tabCategoria

  const handleTabChange = (_: React.SyntheticEvent, val: CategoriaInvitado) => {
    setTabCategoria(val)
    localStorage.setItem(`tabsCenaBaile_${idEvento}`, val)
  }

  return (
    <div>
      <Container fluid className="egresados-page-container">
        {idEvento && (
          <div>
            <Row className="mb-1 align-items-center">
              <Col xs={12} className="egresados-titulo-col">
                <Link to="/admin" className="egresados-volver-link">
                  <Button variant="primary" className="egresados-volver-btn">
                    <i className="bi bi-arrow-left me-2"></i>
                    Volver a eventos
                  </Button>
                </Link>
                <h1 className="egresados-evento-titulo">{tituloEvento}</h1>
              </Col>
            </Row>
            {tipoEvento === TipoEvento.CUMPLEANIOS_BODAS ? (
              <Row xs={12} className={mostrarTabs ? "mb-1" : "mb-4"}>
                <Col className="resumen-evento-grid">
                  <div className="resumen-evento-card">
                    <div className="resumen-evento-card__titulo">Cena</div>
                    <div className="resumen-evento-card__contenido-horizontal">
                      <div className="resumen-evento-card__numero">
                        {totalCena}
                      </div>
                      <div className="resumen-evento-card__detalle-lateral">
                        <div className="resumen-evento-card__fila">
                          <span>Mayores</span>
                          <strong>{totalMayores}</strong>
                        </div>
                        <div className="resumen-evento-card__fila">
                          <span>Menores</span>
                          <strong>{totalMenores}</strong>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="resumen-evento-card">
                    <div className="resumen-evento-card__titulo">Baile</div>
                    <div className="resumen-evento-card__numero">
                      {totalBaile}
                    </div>
                  </div>

                  <div className="resumen-evento-card">
                    <div className="resumen-evento-card__titulo">
                      Adicionales
                    </div>
                    <div className="resumen-evento-card__fila">
                      <span>Mesa dulce</span>
                      <strong>{totalMesaDulce}</strong>
                    </div>
                    <div className="resumen-evento-card__fila">
                      <span>Pos cena</span>
                      <strong>{totalPosCena}</strong>
                    </div>
                    <div className="resumen-evento-card__fila">
                      <span>Barra</span>
                      <strong>{totalBarra}</strong>
                    </div>
                  </div>
                </Col>
              </Row>
            ) : (
              <Row xs={12} className={mostrarTabs ? "mb-1" : "mb-4"}>
                <Col
                  className={`resumen-evento-grid${mostrarTabs ? " resumen-evento-grid--2col" : ""}`}
                >
                  {mostrarTabs ? (
                    <>
                      <div className="resumen-evento-card">
                        <div className="resumen-evento-card__titulo">Cena</div>
                        <div className="resumen-evento-card__contenido-horizontal">
                          <div className="resumen-evento-card__numero">
                            {totalCena}
                          </div>
                          <div className="resumen-evento-card__detalle-lateral">
                            <div className="resumen-evento-card__fila">
                              <span>Mayores</span>
                              <strong>{totalMayores}</strong>
                            </div>
                            <div className="resumen-evento-card__fila">
                              <span>Menores</span>
                              <strong>{totalMenores}</strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="resumen-evento-card">
                        <div className="resumen-evento-card__titulo">Baile</div>
                        <div className="resumen-evento-card__numero">
                          {totalBaile}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="resumen-evento-card">
                        <div className="resumen-evento-card__titulo">
                          Mayores
                        </div>
                        <div className="resumen-evento-card__numero">
                          {totalMayores}
                        </div>
                      </div>

                      <div className="resumen-evento-card">
                        <div className="resumen-evento-card__titulo">
                          Menores
                        </div>
                        <div className="resumen-evento-card__numero">
                          {totalMenores}
                        </div>
                      </div>

                      <div className="resumen-evento-card resumen-evento-card--total">
                        <div className="resumen-evento-card__titulo">Total</div>
                        <div className="resumen-evento-card__numero">
                          {totalGeneral}
                        </div>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            )}
          </div>
        )}

        {skeletonLoading ? (
          <SkeletonGrid />
        ) : (
          <>
            <Snackbar
              open={snackbarOpenError}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              autoHideDuration={3000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="error">
                {snackbarMessageError}
              </Alert>
            </Snackbar>

            <Row className="mt-0">
              <Col sm={12} xs={12}>
                {mostrarTabs && (
                  <Tabs
                    value={tabCategoria}
                    onChange={handleTabChange}
                    sx={{ mb: 2, mt: { xs: 0.75, sm: -2 } }}
                  >
                    <Tab
                      label={`${labelInvitado(tipoEvento)}s Cena`}
                      value={CategoriaInvitado.CENA}
                    />
                    <Tab
                      label={`${labelInvitado(tipoEvento)}s Baile`}
                      value={CategoriaInvitado.BAILE}
                    />
                  </Tabs>
                )}
                <Box
                  sx={{
                    width: {
                      xs: "24rem", // Estilo para móviles
                      md: "100%", // Estilo para pantallas medianas y más grandes
                    },
                  }}
                >
                  <GenericTable
                    data={egresadosFiltrados}
                    columns={columns}
                    actions={actions}
                    onAdd={handleAddModalOpen}
                    onImport={handleImportExcelOpen}
                    onExport={handleExport}
                    onUpdate={handleEditModalOpen}
                    onDelete={showDeleteConfirmation}
                    customSearch={customSearch}
                    onCopy={handleCopy}
                    onViewQR={handleButtonVerQR}
                    onSendPublicQrWhatsapp={handleSendPublicQrWhatsapp}
                    onRecibos={handleRecibosModalOpen}
                    onRecibosEvento={
                      tipoEvento === TipoEvento.CUMPLEANIOS_BODAS && tieneEvento
                        ? () => setRecibosEventoModalShow(true)
                        : undefined
                    }
                    onDeleteAll={
                      tieneEvento ? handleShowDeleteAllConfirmation : undefined
                    }
                    deleteAllLabel={deleteAllLabel}
                    deleteAllDisabled={egresadosFiltrados.length === 0}
                    snackbarOpen={!!copyMessage}
                    snackbarMessage={copyMessage || ""}
                    tieneEvento={tieneEvento}
                    isEgresado
                  />
                </Box>

                {deleteConfirmation && (
                  <Modal
                    show={deleteConfirmation}
                    onHide={() => setDeleteConfirmation(false)}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmar eliminación</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      ¿Estás seguro de que deseas eliminar este egresado de la
                      lista?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => handleDeleteConfirmation(false)}
                      >
                        No
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => handleDeleteConfirmation(true)}
                      >
                        Sí
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}

                <AddEgresadoModal
                  show={addModalShow}
                  handleClose={handleAddModalClose}
                  handleEgresadoAdd={handleEgresadoAdd}
                  idEvento={idEvento}
                  tipoEvento={tipoEvento}
                  categoriaDefault={categoriaDefault}
                />

                <ImportExcelModal
                  show={importExcelShow}
                  handleClose={handleImportExcelClose}
                  handleImport={handleImportExcel}
                  idEvento={idEvento}
                  tipoEvento={tipoEvento}
                  categoriaDefault={categoriaDefault}
                />

                {editModalShow && (
                  <EditEgresadoModal
                    show={editModalShow}
                    handleClose={handleEditModalClose}
                    handleEgresadoEdit={handleEgresadoEdit}
                    selectedEgresado={selectedEditUsuario}
                    idEvento={idEvento}
                    tipoEvento={tipoEvento}
                  />
                )}
                {recibosModalShow && (
                  <RecibosModal
                    show={recibosModalShow}
                    handleClose={handleRecibosModalClose}
                    handleReciboAdd={handleReciboAdd}
                    idEgresado={idEgresado}
                    idEvento={idEvento}
                    tipoEvento={tipoEvento ?? undefined}
                  />
                )}
                {recibosEventoModalShow && (
                  <RecibosEventoModal
                    show={recibosEventoModalShow}
                    handleClose={() => setRecibosEventoModalShow(false)}
                    handleReciboEventoAdd={handleReciboEventoAdd}
                    idEvento={idEvento}
                    tipoEvento={tipoEvento ?? undefined}
                    nombreEvento={tituloEvento}
                    telefonoEvento={telefonoEvento}
                    nombreClienteEvento={nombreClienteEvento}
                  />
                )}
                {openQRModal && (
                  <ModalGeneradorQR
                    open={openQRModal}
                    onClose={handleCloseQRModal}
                    dni={dniQR}
                    clave={claveQR}
                    id={idQR}
                    tipoEvento={tipoEventoQR}
                    categoria={categoriaQR}
                  />
                )}
              </Col>
            </Row>
            <Modal
              show={showDeleteAllConfirmation}
              onHide={handleCloseDeleteAllConfirmation}
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirmar eliminación</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                ¿Estás seguro de que deseas eliminar todos los{" "}
                {labelInvitado(tipoEvento).toLowerCase()}s
                {mostrarTabs
                  ? ` de ${tabCategoria === CategoriaInvitado.BAILE ? "Baile" : "Cena"}`
                  : ""}
                ?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={handleCloseDeleteAllConfirmation}
                >
                  No
                </Button>
                <Button
                  variant="danger"
                  onClick={() => handleDeleteAllConfirmation(true)}
                >
                  Sí
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showSecondDeleteConfirmation}
              onHide={() => setShowSecondDeleteConfirmation(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirmar eliminación final</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                ¿Estás seguro de que deseas eliminar{" "}
                <strong>definitivamente</strong> todos los{" "}
                {labelInvitado(tipoEvento).toLowerCase()}s
                {mostrarTabs
                  ? ` de ${tabCategoria === CategoriaInvitado.BAILE ? "Baile" : "Cena"}`
                  : ""}{" "}
                de este evento?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowSecondDeleteConfirmation(false)}
                >
                  No
                </Button>
                <Button
                  variant="danger"
                  onClick={handleFinalDeleteAllEgresados}
                >
                  Sí, eliminar
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={showGenerarReciboConfirm}
              onHide={handleGenerarReciboCancel}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Generar Recibo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                ¿Desea generar recibo para{" "}
                <strong>
                  {tipoEvento === TipoEvento.CUMPLEANIOS_BODAS
                    ? tituloEvento
                    : `${capitalizeNombresPropios(egresadoParaRecibo?.nombre || "")} ${capitalizeNombresPropios(egresadoParaRecibo?.apellido || "")}`}
                </strong>
                ?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleGenerarReciboCancel}>
                  Cancelar
                </Button>
                <Button variant="primary" onClick={handleGenerarReciboConfirm}>
                  Sí, generar
                </Button>
              </Modal.Footer>
            </Modal>
            <TelefonoWhatsappModal
              show={!!egresadoWhatsappPendiente}
              nombre={
                egresadoWhatsappPendiente
                  ? `${capitalizeNombresPropios(
                      egresadoWhatsappPendiente.nombre || "",
                    )} ${capitalizeNombresPropios(
                      egresadoWhatsappPendiente.apellido || "",
                    )}`.trim()
                  : ""
              }
              telefono={telefonoWhatsapp}
              onTelefonoChange={setTelefonoWhatsapp}
              onCancel={() => {
                setEgresadoWhatsappPendiente(null)
                setTelefonoWhatsapp("")
              }}
              onConfirm={handleGuardarTelefonoYEnviarQr}
              isSaving={guardandoTelefonoWhatsapp}
            />
            <QrNoTicketsModal
              open={qrNoTicketsOpen}
              message={qrNoTicketsMessage}
              onClose={() => setQrNoTicketsOpen(false)}
            />
          </>
        )}
      </Container>
    </div>
  )
}
export default Egresados
